<template>
  <div class="payManagement">
    <img class="logo" src="~@/assets/images/logoa.png" />
    <div class="return">
      <el-button @click="$router.back()" slot="btn" class="backBtn">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-fanhui1"></use>
        </svg>
        返回
      </el-button>
    </div>
    <div class="qrCodeCon">
      <p>扫描二维码联系客服</p>
      <img src="~@/assets/images/IMG_8906_2.png" />
      <span>请联系客服，客服会给您解决续费升级等问题！</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payManagement',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.payManagement {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: #0f1014;
  .logo {
    position: absolute;
    top: 59px;
    left: 63px;
  }
  .return {
    position: absolute;
    right: 63px;
    top: 59px;
  }
  .qrCodeCon {
    width: 600px;
    height: 500px;
    background: #282a2b;
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    p {
      font-size: 30px;
      color: #fff;
      margin: 0;
    }
    img {
      width: 190px;
    }
    span {
      font-size: 16px;
    }
  }
}
</style>
